import type { TokenCatalogEntry } from '@/data/marketApi/types'
import { isWrappedNativeAddress } from '@/data/marketApi/normalizeMarketToken'
import { ChainId, Currency, Token } from '../../sdk'

import {
  catalogEntriesToSwapCurrencies,
  catalogEntriesToVisibleCurrencies,
  currencyKey,
  isCatalogKnownAddress,
  resolveCurrencyFromCatalog,
} from '../tokens/tokenCatalogRuntime'

export { currencyKey } from '../tokens/tokenCatalogRuntime'

/** Monedas visibles para UI: catálogo de producto + tokens importados (sin wrapped native). */
export function buildVisibleCatalogCurrencies(
  chainId: ChainId,
  catalogEntries: readonly TokenCatalogEntry[],
  userTokens?: readonly Token[],
): Currency[] {
  const byKey = new Map<string, Currency>()
  for (const currency of catalogEntriesToVisibleCurrencies(chainId, catalogEntries)) {
    byKey.set(currencyKey(currency), currency)
  }
  for (const token of userTokens ?? []) {
    if (token.chainId === chainId && !isWrappedNativeAddress(token.address, chainId)) {
      byKey.set(token.address.toLowerCase(), token)
    }
  }
  return [...byKey.values()]
}

/** Monedas para motor de swap/routing: catálogo + hubs wrapped + tokens importados. */
export function buildSwapCatalogCurrencies(
  chainId: ChainId,
  catalogEntries: readonly TokenCatalogEntry[],
  userTokens?: readonly Token[],
): Currency[] {
  const byKey = new Map<string, Currency>()
  for (const currency of catalogEntriesToSwapCurrencies(chainId, catalogEntries)) {
    byKey.set(currencyKey(currency), currency)
  }
  for (const token of userTokens ?? []) {
    if (token.chainId === chainId && !isWrappedNativeAddress(token.address, chainId)) {
      byKey.set(token.address.toLowerCase(), token)
    }
  }
  return [...byKey.values()]
}

export function isTokenInSwapCatalog(
  chainId: ChainId,
  token: Token,
  catalogEntries: readonly TokenCatalogEntry[],
  userTokens?: readonly Token[],
): boolean {
  return isCatalogKnownAddress(chainId, token.address, catalogEntries, userTokens)
}

export function resolveSwapCurrencyFromCatalog(
  chainId: ChainId,
  currencyId: string | undefined,
  catalogEntries: readonly TokenCatalogEntry[],
): Currency | undefined {
  return resolveCurrencyFromCatalog(chainId, currencyId, catalogEntries)
}
